export function detectBrowser(): string {
	const browsers = [ "Chrome", "MSIE", "Firefox", "Safari", "OP" ];

	const matches = browsers.filter( ( browser ): boolean => {
		return navigator.userAgent.indexOf( browser ) > -1;
	} );

	if ( matches.length === 0 ) {
		return "Unknown";
	}

	// Disregard Chrome and Safari since it also matches Opera.
	if ( matches.includes( "OP" ) ) {
		return "Opera";
	}

	// Discard Safari since it also matches Chrome.
	if ( matches.includes( "Chrome" ) && matches.includes( "Safari" ) ) {
		return "Chrome";
	}

	return matches[0];
}
